module.exports = __webpack_public_path__ + "static/media/back.698abbb0.svg";